<div class="inner-wrapper is-{{ appearance() }}" [ngClass]="widthClass" [ngStyle]="customWidth">
  @if (icon) {
    <mat-icon [class.mat-icon-rtl-mirror]="rtlMirrorIcon()" [svgIcon]="icon"></mat-icon>
  }
  <span><ng-content></ng-content></span>
</div>
